import reducer from './reducers';

import * as lingualOperations from './operations';
import * as lingualSelectors from './selectors';

export { lingualOperations, lingualSelectors };

export default reducer;
